import React, { createContext, useContext, useState, useEffect } from 'react';
import AsyncStorage from '../services/AsyncStorage';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      const token = await AsyncStorage.getItem('token');
      const role = await AsyncStorage.getItem('admin_role');
      const adminId = await AsyncStorage.getItem('admin_id');
      if (token && role) setUser({ token, role, adminId });
      setLoading(false);
    };
    init();
  }, []);

  const login = async (data) => {
    await AsyncStorage.setItem('token', data.token);
    await AsyncStorage.setItem('admin_role', data.role);
    await AsyncStorage.setItem('admin_id', String(data.adminId));
    await AsyncStorage.setItem('Login', 'true');
    setUser({ token: data.token, role: data.role, adminId: data.adminId });
  };

  const logout = async () => {
    await AsyncStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
